import { axiosInstance } from "../../config/dataProvider";
import { stringify } from "query-string";

export const api = {
  // Customers
  getCustomers: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/customers?${query}`)
      .then((res) => res.data);
  },
  getCustomer: (id) =>
    axiosInstance
      .get(`/customers/${id}`)
      .then((res) => res.data),
  createCustomer: (data) =>
    axiosInstance
      .post("/customers", data)
      .then((res) => res.data),
  updateCustomer: (id, data) =>
    axiosInstance
      .patch(`/customers/${id}`, data)
      .then((res) => res.data),
  deleteCustomer: (id) =>
    axiosInstance
      .delete(`/customers/${id}`)
      .then((res) => res.data),
  sendDirectNotification: (id, data) =>
    axiosInstance
      .post(`/customers/${id}/send-notification`, data)
      .then((res) => res.data),
  getCustomerFunnelStats: (params = {}) => {
    const query = stringify(params);
    return axiosInstance
      .get(`/customers/funnel${query ? `?${query}` : ""}`)
      .then((res) => res.data);
  },

  // Customer Funnels
  getCustomerFunnels: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "order:asc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/customerFunnels?${query}`)
      .then((res) => res.data);
  },
  getCustomerFunnel: (id) =>
    axiosInstance
      .get(`/customerFunnels/${id}`)
      .then((res) => res.data),
  createCustomerFunnel: (data) =>
    axiosInstance
      .post("/customerFunnels", data)
      .then((res) => res.data),
  updateCustomerFunnel: (id, data) =>
    axiosInstance
      .patch(`/customerFunnels/${id}`, data)
      .then((res) => res.data),
  deleteCustomerFunnel: (id) =>
    axiosInstance
      .delete(`/customerFunnels/${id}`)
      .then((res) => res.data),
  getActiveCustomerFunnels: () =>
    axiosInstance
      .get("/customerFunnels/active")
      .then((res) => res.data),

  // Users
  getUsers: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/users?${query}`)
      .then((res) => res.data);
  },
  getUser: (id) =>
    axiosInstance
      .get(`/users/${id}`)
      .then((res) => res.data),
  createUser: (data) =>
    axiosInstance
      .post("/users", data)
      .then((res) => res.data),
  updateUser: (id, data) =>
    axiosInstance
      .patch(`/users/${id}`, data)
      .then((res) => res.data),
  deleteUser: (id) =>
    axiosInstance
      .delete(`/users/${id}`)
      .then((res) => res.data),

  // Subscriptions
  getSubscriptions: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/subscriptions?${query}`)
      .then((res) => res.data);
  },
  getSubscription: (id) =>
    axiosInstance
      .get(`/subscriptions/${id}`)
      .then((res) => res.data),
  createSubscription: (data) =>
    axiosInstance
      .post("/subscriptions", data)
      .then((res) => res.data),
  updateSubscription: (id, data) =>
    axiosInstance
      .patch(`/subscriptions/${id}`, data)
      .then((res) => res.data),
  deleteSubscription: (id) =>
    axiosInstance
      .delete(`/subscriptions/${id}`)
      .then((res) => res.data),

  // Notifications
  getNotifications: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/notifications?${query}`)
      .then((res) => res.data);
  },
  getNotification: (id) =>
    axiosInstance
      .get(`/notifications/${id}`)
      .then((res) => res.data),
  getSentNotifications: (params = {}) => {
    const query = stringify({
      page: params.page || 1,
      limit: params.limit || 50,
    });
    return axiosInstance
      .get(`/notifications/sent?${query}`)
      .then((res) => res.data);
  },
  createNotification: (data) => {
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return axiosInstance
      .post("/notifications", data, config)
      .then((res) => res.data);
  },
  updateNotification: (id, data) => {
    const config =
      data instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return axiosInstance
      .patch(`/notifications/${id}`, data, config)
      .then((res) => res.data);
  },
  deleteNotification: (id) =>
    axiosInstance
      .delete(`/notifications/${id}`)
      .then((res) => res.data),
  deleteAllCustomerNotifications: () =>
    axiosInstance
      .delete(
        "/notifications/customer-notifications/delete-all"
      )
      .then((res) => res.data),
  toggleNotificationEnabled: (id) =>
    axiosInstance
      .patch(`/notifications/${id}/toggle-enabled`)
      .then((res) => res.data),

  // Achievements
  getAchievements: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/achievements?${query}`)
      .then((res) => res.data);
  },
  getAchievement: (id) =>
    axiosInstance
      .get(`/achievements/${id}`)
      .then((res) => res.data),
  createAchievement: (data) =>
    axiosInstance
      .post("/achievements", data)
      .then((res) => res.data),
  updateAchievement: (id, data) =>
    axiosInstance
      .patch(`/achievements/${id}`, data)
      .then((res) => res.data),
  deleteAchievement: (id) =>
    axiosInstance
      .delete(`/achievements/${id}`)
      .then((res) => res.data),

  // App Versions
  getAppVersions: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/appVersions?${query}`)
      .then((res) => res.data);
  },
  getAppVersion: (id) =>
    axiosInstance
      .get(`/appVersions/${id}`)
      .then((res) => res.data),
  createAppVersion: (formData) => {
    const config =
      formData instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return axiosInstance
      .post("/appVersions", formData, config)
      .then((res) => res.data);
  },
  updateAppVersion: (id, formData) => {
    const config =
      formData instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return axiosInstance
      .patch(`/appVersions/${id}`, formData, config)
      .then((res) => res.data);
  },
  deleteAppVersion: (id) =>
    axiosInstance
      .delete(`/appVersions/${id}`)
      .then((res) => res.data),
  uploadAppVersionToLambdaTest: (id, data) =>
    axiosInstance
      .post(`/appVersions/${id}/upload-to-lambdatest`, data)
      .then((res) => res.data),

  // Whats New
  getWhatsNew: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/whatsNew?${query}`)
      .then((res) => res.data);
  },
  getWhatsNewItem: (id) =>
    axiosInstance
      .get(`/whatsNew/${id}`)
      .then((res) => res.data),
  createWhatsNew: (data) =>
    axiosInstance
      .post("/whatsNew", data)
      .then((res) => res.data),
  updateWhatsNew: (id, data) =>
    axiosInstance
      .patch(`/whatsNew/${id}`, data)
      .then((res) => res.data),
  deleteWhatsNew: (id) =>
    axiosInstance
      .delete(`/whatsNew/${id}`)
      .then((res) => res.data),

  // Features
  getFeatures: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/features?${query}`)
      .then((res) => res.data);
  },
  getFeature: (id) =>
    axiosInstance
      .get(`/features/${id}`)
      .then((res) => res.data),
  createFeature: (data) =>
    axiosInstance
      .post("/features", data)
      .then((res) => res.data),
  updateFeature: (id, data) =>
    axiosInstance
      .patch(`/features/${id}`, data)
      .then((res) => res.data),
  deleteFeature: (id) =>
    axiosInstance
      .delete(`/features/${id}`)
      .then((res) => res.data),

  // Jobs
  getJobs: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/jobs?${query}`)
      .then((res) => res.data);
  },
  getJobDetails: (name) =>
    axiosInstance
      .get(`/jobs/details/${name}`)
      .then((res) => res.data),
  getJobExecutionHistory: (name, limit = 20) => {
    const query = stringify({ limit });
    return axiosInstance
      .get(`/jobs/history/${name}?${query}`)
      .then((res) => res.data);
  },
  startJob: (data) =>
    axiosInstance
      .post("/jobs/start", data)
      .then((res) => res.data),
  pauseJob: (data) =>
    axiosInstance
      .post("/jobs/pause", data)
      .then((res) => res.data),
  resumeJob: (data) =>
    axiosInstance
      .post("/jobs/resume", data)
      .then((res) => res.data),
  runJobWithSimulatedTime: (data) =>
    axiosInstance
      .post("/jobs/run-with-simulated-time", data)
      .then((res) => res.data),
  runScheduledNotificationForTime: (data) =>
    axiosInstance
      .post(
        "/jobs/run-scheduled-notification-for-time",
        data
      )
      .then((res) => res.data),
  getScheduledNotificationJobs: () =>
    axiosInstance
      .get("/jobs/scheduled-notifications")
      .then((res) => res.data),
  getNotificationDiscoveryStatus: () =>
    axiosInstance
      .get("/jobs/discovery-status")
      .then((res) => res.data),
  refreshScheduledJobs: () =>
    axiosInstance
      .post("/jobs/refresh-scheduled")
      .then((res) => res.data),

  // Test Runs
  getTestRuns: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/testRuns?${query}`)
      .then((res) => res.data);
  },
  getTestRun: (id) =>
    axiosInstance
      .get(`/testRuns/${id}`)
      .then((res) => res.data),
  runTests: (data) =>
    axiosInstance
      .post("/testRuns", data)
      .then((res) => res.data),

  // LambdaTest
  getLambdaTestDevices: (region) => {
    const query = region ? stringify({ region }) : "";
    return axiosInstance
      .get(
        `/testRuns/lambdatest/devices${
          query ? `?${query}` : ""
        }`
      )
      .then((res) => res.data);
  },
  getLambdaTestApps: (type = "android", level = "user") => {
    const query = stringify({ type, level });
    return axiosInstance
      .get(`/testRuns/lambdatest/apps?${query}`)
      .then((res) => res.data);
  },
  uploadAppToLambdaTest: (formData) => {
    const config =
      formData instanceof FormData
        ? {
            headers: {
              "Content-Type": "multipart/form-data",
            },
          }
        : {};
    return axiosInstance
      .post("/testRuns/lambdatest/upload", formData, config)
      .then((res) => res.data);
  },

  // Test Cases
  getTestCases: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "code:asc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/testCases?${query}`)
      .then((res) => res.data);
  },
  getTestCase: (id) =>
    axiosInstance
      .get(`/testCases/${id}`)
      .then((res) => res.data),
  getTestCasesStats: (params = {}) => {
    const query = stringify(params);
    return axiosInstance
      .get(`/testCases/stats${query ? `?${query}` : ""}`)
      .then((res) => res.data);
  },
  importTestCases: () =>
    axiosInstance
      .post("/testCases")
      .then((res) => res.data),

  // Help Center
  getConversations: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 10,
      ...params.filter,
    });
    return axiosInstance
      .get(`/assistant/conversations?${query}`)
      .then((res) => res.data);
  },
  sendMessage: (data) =>
    axiosInstance
      .post("/assistant/conversations/send", data)
      .then((res) => res.data),
  generateResponse: (id) =>
    axiosInstance
      .post(
        `/assistant/conversations/generateResponse/${id}`
      )
      .then((res) => res.data),

  // Prompt Templates
  getPromptTemplates: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "key:asc,locale:asc",
      page: params.page || 1,
      limit: params.limit || 100,
      ...params.filter,
    });
    return axiosInstance
      .get(`/promptTemplates?${query}`)
      .then((res) => res.data);
  },
  getPromptTemplate: (id) =>
    axiosInstance
      .get(`/promptTemplates/${id}`)
      .then((res) => res.data),
  createPromptTemplate: (data) =>
    axiosInstance
      .post("/promptTemplates", data)
      .then((res) => res.data),
  updatePromptTemplate: (id, data) =>
    axiosInstance
      .patch(`/promptTemplates/${id}`, data)
      .then((res) => res.data),
  deletePromptTemplate: (id) =>
    axiosInstance
      .delete(`/promptTemplates/${id}`)
      .then((res) => res.data),

  // Prompt Usage
  getPromptUsages: (params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 50,
      ...params.filter,
    });
    return axiosInstance
      .get(`/promptUsages?${query}`)
      .then((res) => res.data);
  },
  getPromptUsage: (id) =>
    axiosInstance
      .get(`/promptUsages/${id}`)
      .then((res) => res.data),
  getPromptUsageStats: (params = {}) => {
    const query = stringify(params);
    return axiosInstance
      .get(`/promptUsages/stats${query ? `?${query}` : ""}`)
      .then((res) => res.data);
  },
  getDailyUsageStats: (params = {}) => {
    const query = stringify(params);
    return axiosInstance
      .get(`/promptUsages/daily${query ? `?${query}` : ""}`)
      .then((res) => res.data);
  },
  getPromptUsageByCustomer: (customerId, params = {}) => {
    const query = stringify({
      sortBy: params.sortBy || "createdAt:desc",
      page: params.page || 1,
      limit: params.limit || 50,
    });
    return axiosInstance
      .get(`/promptUsages/customer/${customerId}?${query}`)
      .then((res) => res.data);
  },
};
